import { Toaster as SonnerToaster } from 'sonner';

export const Toaster = () => (
  <SonnerToaster
    position="bottom-center"
    richColors
    closeButton
    theme="dark"
    toastOptions={{
      style: {
        background: 'var(--color-surface)',
        color: 'var(--color-foreground)',
        border: '1px solid var(--color-border-subtle)',
      },
    }}
  />
);
